window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

casino.repos.bannerRepo = function () {
    var list = function(showOnlyActive) {
        var url = casino.repos.base.makeUrl('api/casinobanners') + '?c=' + casino.config.guiCacheVerzija;

        if (showOnlyActive)
            url += '&showOnlyActive=' + showOnlyActive;

        return fetch(url)
          .then(casino.repos.base.checkResponse)
          .then(function(response) {
            return response.json();
          })
          .catch(casino.repos.base.handleNetworkException);
      };

    return {
        list: list,
    }
}();